import React from 'react';
import useFormDataLayer from '../logic/useFormDataLayer';
import FormField from './Field';
import RadioGroup from '../fields/RadioGroup';

var ConnectedDropdown = function ConnectedDropdown(_ref) {
  var fieldId = _ref.fieldId;
  var fieldData = useFormDataLayer(fieldId);
  var value = fieldData.value,
      dispatch = fieldData.dispatch,
      error = fieldData.error,
      active = fieldData.active,
      description = fieldData.description;
  var labelPlacement = fieldData.labelPlacement,
      caption = fieldData.caption,
      _fieldData$required = fieldData.required,
      required = _fieldData$required === void 0 ? false : _fieldData$required,
      options = fieldData.options,
      readonly = fieldData.readonly;
  return React.createElement(FormField, {
    label: caption,
    labelPlacement: labelPlacement || 'left',
    required: required
  }, React.createElement(RadioGroup, {
    active: active,
    fieldId: fieldId,
    options: options,
    value: value,
    dispatch: dispatch,
    error: error,
    readonly: readonly,
    description: description
  }));
};

export default React.memo(ConnectedDropdown);